import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TDropdown } from 'src/app/project/components/dropdown/dropdown.consts';

import { DeviceService } from 'src/app/core/services/device.service';
import { DropdownService } from 'src/app/project/components/dropdown/dropdown-service/dropdown.service';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';

import { TExportTypeGroup } from 'src/app/project/modules/exports/point-export-modal/export-types';
import { TSelectDropdownItems } from '../select/select-dropdown/select-dropdown.model';

@Component({
  selector: 'pp-select-categorised-dropdown',
  templateUrl: './select-categorised-dropdown.component.html',
  styleUrls: ['./select-categorised-dropdown.component.scss'],
  standalone: false,
})
export class SelectCategorisedDropdownComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  isMobile = false;
  filteredItems: unknown[] = [];
  selectedItem: unknown = null;
  EIconPath = EIconPath;
  displaySubtext = false;

  private dropdown: TDropdown = this.dropdownService.getDropdown();

  items: TExportTypeGroup[];

  constructor(
    private dropdownService: DropdownService,
    private deviceService: DeviceService,
  ) {
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit(): void {
    this.setDataFromDropdown();

    this.dropdownService.dropdownDataChanged$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.setDataFromDropdown();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  hideDropdown(): void {
    this.dropdownService.hideDropdown();
  }

  selectItem(item: string | unknown): void {
    this.dropdown.callback(item);

    this.hideDropdown();
  }

  clearAll(): void {
    this.dropdown.callback();
    this.hideDropdown();
  }

  private setDataFromDropdown(): void {
    const dropdownData: TSelectDropdownItems = this.dropdown.data;

    this.items = dropdownData.items;
    this.selectedItem = dropdownData.selectedItem;
    this.displaySubtext = dropdownData.displaySubtext;
  }
}
